import { RelatorioDistribuidorRepository } from "../repository/relatorio_distribuidor_repository";

export class RelatorioDistribuidorService {
	constructor() {
		this.repository = new RelatorioDistribuidorRepository();
	}

	async fetchVisaoGeral(dataInicio, dataFim) {
		return await this.repository.fetchVisaoGeral(dataInicio, dataFim);
	}

	async fetchEntradas(dataInicio, dataFim, status, fornecedorId, search) {
		return await this.repository.fetchEntradas(dataInicio, dataFim, status, fornecedorId, search);
	}

	async fetchSaidas(dataInicio, dataFim, destinoId, search) {
		return await this.repository.fetchSaidas(dataInicio, dataFim, destinoId, search);
	}

	async fetchBalanco(dataInicio, dataFim, produto, fornecedor, search) {
		return await this.repository.fetchBalanco(dataInicio, dataFim, produto, fornecedor, search);
	}

	async fetchRastreabilidade(search) {
		return await this.repository.fetchRastreabilidade(search);
	}
}

export default RelatorioDistribuidorService;
